'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Common.RefreshNotification', dependencies).controller('RefreshNotificationModalController', require('./controllers/RefreshNotificationModalController')).directive('rmRefreshNotificationModal', require('./directives/RefreshNotificationModalDirective'));